<template>
  <b-modal width="320px" :active.sync="active" :on-cancel="cancel">
    <div class="card">
      <div class="explaination">
        <p>以下の記号をつけることで検索に条件をつけることができます。</p>
      </div>
      <div>
        <div class="item">
          <p class="name">AND検索</p>
          <p class="arrow">→</p>
          <p class="and">&</p>
        </div>
        <div class="item">
          <p class="name">OR検索</p>
          <p class="arrow">→</p>
          <p class="and">|</p>
        </div>
        <div class="item">
          <p class="name">NOT検索</p>
          <p class="arrow">→</p>
          <p class="and">~</p>
        </div>
      </div>
      <div class="example">
        <p>(例)東京都&港区</p>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  props: {
    active: {
      type: Boolean,
      required: true
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
    }
  }
};
</script>

<style scoped lang="scss">
.card {
  border-radius: 5px;
  padding: 16px;
}
.item {
  display: flex
}
.name {
  width: 80px;
}
.arrow {
  width: 40px;
}
.and {
  font-weight: bold;
}
.example {
  margin-top: 16px;
}
.explaination {
  margin-bottom: 16px
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/modals/ModalSearchQA.vue